var navbar = {
    elSelector: '#navbar',
    el: null, // needs to be set on init using elSelector
    offset: 0, // (px) is set on init
    duration: 500, // (ms) css transition minimize/maximize
    delta: 50, // (px) user has to scroll x to toggle navbar
    transitioning: false, // changing state
    buffer: 200, // (px) close nav on scroll up x before
    isFixed: false, // default not fixed
    isMinimized: true, // default is minimized
    didScroll: false,
    lastScrollTop: 0,
    initialized: false,
    isMobile: !Modernizr.mq("screen and (min-width:992px)"),
    isTablet: Modernizr.mq("screen and (max-width:1024px)"),

    // Prgress bar: https://css-tricks.com/reading-position-indicator/
    // navbar jumps because _this.progressBar is in #navbar for some reason...
    updateProgressBar: function() {
        var _this = this;
        if ( _this.progressBar.length < 1 ) { return }

        if ( $('#page_content').length > 0 ) {
            var contentBottom = $('#page_content').height() + $('#page_content').offset().top;
            var max = contentBottom - $(window).height() - _this.offset;
        } else {
            var max = $(document).height() - $(window).height() - _this.offset;
        }

        _this.progressBar.attr('max', max);

        // update value
        var value = $(window).scrollTop() - _this.offset;

        _this.progressBar.attr('value', value);
    },
    // fade in
    fix: function(){
        var _this = this;
        if (_this.isFixed) { return; }

        // if mobile menu open: dont show navbar
        if ($('body').hasClass('menu-on')) { return; }

        _this.el.addClass('fixed');
        _this.isFixed = true;

        // start autoplay on agent slider
        if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
            if ( _this.el.find('.agent-slider').length > 0 ) {
                if ( _this.el.find('.agent-slider').hasClass('slick-initialized') ) {
                    _this.el.find('.agent-slider').slick('play');
                    _this.el.find('.agent-slider').slick('setOption', 'autoplay', true); // to set pause on hover option
                }
            }
        }
    },
    // fade out
    unfix: function() {
        var _this = this;
        if (!_this.isFixed) { return; }
        _this.el.removeClass('fixed');
        _this.isFixed = false;

        // pause autoplay on agent slider
        if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {

            if ( _this.el.find('.agent-slider').length > 0 ) {
                if ( _this.el.find('.agent-slider').hasClass('slick-initialized') ) {
                    _this.el.find('.agent-slider').slick('pause');
                    _this.el.find('.agent-slider').slick('setOption', 'autoplay', false); // to set pause on hover option
                    _this.el.find('.agent-slider').slick('slickGoTo',0);
                }
            }
        } else if ( $("#agent_modal").length > 0 ) {
            // if modal agent is open: close it (otherwise can not close it since fixed nav is gone)
            if ( $("#agent_modal").hasClass('in') ) {
                $("#agent_modal").find('.modal-close').trigger('click');
                $('#navbar').find('.agent-item .enquire_project_product_agent').removeClass('off');
            }
        }
    },
    minimize: function(){
        if (this.isMinimized) { return; }
        // Hide top section
        if ( this.el.hasClass('is-maximized') ) {
            this.transition();
        }
        this.el.removeClass('is-maximized').addClass('is-minimized');
        this.isMinimized = true;
    },
    maximize: function() {
        if (!this.isMinimized) { return; }
        // Show top section
        if ( this.el.hasClass('is-minimized') ) {
            this.transition();
        }
        this.el.removeClass('is-minimized').addClass('is-maximized');
        this.isMinimized = false;
    },
    transition: function() {
        var _this = this;

        // could have transition in css and toggle class is-transitioning here
        // but we're using duration for the setTimeout so easier to have everything together in js

        // top menu visible
        //_this.el.find('.top-section').css('visibility','visible');

        var transitions = {
            '-webkit-transform' : 'transform ' + _this.duration +'ms',
            '-moz-transform'    : 'transform ' + _this.duration +'ms',
            '-ms-transform'     : 'transform ' + _this.duration +'ms',
            '-o-transform'      : 'transform ' + _this.duration +'ms',
            'transition'        : 'transform ' + _this.duration +'ms'
        }

        // add css transition
        _this.transitioning = true;
        _this.el.css(transitions);
        _this.el.find('.navbar-logo').css(transitions);
        _this.el.find('#trigger-form').css(transitions);

        // var duration = _this.duration;
        // var duration = _this.duration = 100;
        var duration = _this.duration + 200;

        // remove css transform when transition is done
        setTimeout(function(){
            _this.el.css('transition','');
            _this.el.find('.navbar-logo').css('transition','none');
            _this.el.find('#trigger-form').css('transition','none');
            _this.transitioning = false;
            // top menu hidden
            // if ( _this.el.hasClass('is-minimized') ) {
            //     _this.el.find('.top-section').css('visibility','hidden');
            // }
        }, duration)

    },
    toggleFix: function(st) {
        var _this = this;

        // If shouldnt be fixed
        if (st <= _this.offset) {
            _this.reset();

        } else {
            // Navbar should be fixed
            _this.fix();
        }
    },
    handleScroll: function() {
        var _this = this;
        var st = $(window).scrollTop(); // int
        var down = st > _this.lastScrollTop; // bool
        //var navbar_height = this.el.outerHeight();
        var navbarVisibleHeight = _this.el.find('.bottom-section').outerHeight();

        // ===== Toggle Fixed State
        _this.toggleFix(st);

        // don't go further if nav is not fixed
        if (!_this.isFixed) return;

        // don't do anything else if is not stacker (nothing to do on scroll up)
        // if ( !_this.el.hasClass('has-stacker-nav') ) return;

        // ===== Small screens

        // if small screen, toggle fix state (offst different than on desktop)
        // top menu must be closed (this can be done once on resize)
        // and then return ( dont want to toggle top section);
        if ( _this.isTablet ) {
             _this.minimize();
            return;
        }

        // ===== Toggle Top Section

        // Do nothing if suser didn't scroll enough
        if (Math.abs(_this.lastScrollTop - st) <= _this.delta ) { return; }

        // Scroll Down (hide top section)
        if (down){
            // if scrolled past top section
            if ( st > navbarVisibleHeight) { _this.minimize(); }
        }
        // Scroll up : hide top section buffer (x before offset)
        // can't open top section if too close to offset + when scrolling back up, close top section before reaching offset
        else if ( st < _this.offset + _this.buffer) {
            if ( $('body').hasClass('side-panel_open') || $('body').hasClass('scrolling-to-section') ) return;

            _this.minimize();
        }
        // Scroll Up : show top section (if side panel not opened and if not scrolling up with stacker nav )
        // If did not scroll past the document (possible on mac)...
        else if (st + $(window).height() < $(document).height() && !$('body').hasClass('side-panel_open') && !$('body').hasClass('scrolling-to-section') ) {

             _this.maximize();
        }

        _this.lastScrollTop = st;
    },
    handleLogoClick: function(e) {
        var _this = this;
        e.preventDefault();
        // show top menu or link to home page
        if ( _this.isMinimized && !_this.isTablet ) {
            _this.maximize();
        } else if ( $('#site_container').hasClass('home-page') ) {
            $('body,html').stop().animate({
                'scrollTop':0
            }, 800);
        }
        else {
            // go to home page
            window.app.loadUrl('/');
        }
    },
    updateStackerNavLeft: function() {
        var _this = this;

        if ( !_this.el.hasClass('has-stacker-nav') ) { return; }

        var stackerNav = _this.el.find('.stacker-nav-container');
        var left = _this.el.find('.stacker-line .line').offset().left - parseInt(stackerNav.css('margin-left'));

        stackerNav.css('left', left);
        stackerNav.removeClass('loading');

    },
    checkCtaVisibility: function() {
        // Don't show "tell us your needs" button on coworking page
        var currentPage = document.getElementById('main');
        var header = document.getElementById('header');
        var ctaBtns = header.getElementsByClassName('cta-btn');
        var needsBtn = ctaBtns[0];
        if (currentPage.getAttribute('data-page-key') === 'coworking') {
            needsBtn.classList.add('hide-cta');
        } else {
            needsBtn.classList.remove('hide-cta');
        }
    },
    init: function() {

        if ( this.initialized ) return;

        var _this = this;

        _this.checkCtaVisibility();

        if ( !$(_this.elSelector).length ) return;

        _this.el = $(_this.elSelector);
        _this.progressBar = $('progress');

        _this.initialized = true;

        // === SET NAVBAR OFFSET
        _this.setOffset();

        // === INIT SIDE PANEL
        //sidePanel.init(id); // give navbar id

        // === SCROLL
        $(window).scroll(function(event){
            _this.didScroll = true;
        });

        setInterval(function() {
            if (_this.didScroll) {
                _this.updateProgressBar();
                _this.handleScroll();
                _this.didScroll = false;
            }
        }, 100);

        // === CLICK ON LOGO
        var logo = _this.el.find('.bottom-section .navbar-logo');
        logo.on('click', function(e) {
            _this.handleLogoClick(e);
        } );


        // === Stacker nav
        // is displaying by default.
        // need to update left.
        _this.updateStackerNavLeft();

        // === Reset on resize
        $(window).smartresize(function(){
            _this.updateProgressBar();
            _this.reset();
            _this.toggleFix($(window).scrollTop());
            _this.updateStackerNavLeft();
        })
    },
    reset: function() {
        var _this = this;
        // unfix nav
        _this.unfix();

        // minimize
        _this.minimize();

        // reset offset
        _this.setOffset();

        _this.isTablet = Modernizr.mq("screen and (max-width:1024px)");
    },
    setOffset: function() {
        if ( !this.el ) { return; }
        //this.offset = this.el.offset().top + this.el.find('.top-section').outerHeight();
        this.offset = this.el.offset().top;
    },
    destroy: function() {
        var _this = this;
        _this.reset();
        _this.initialized = false;
    }
};